export { default } from '../modules/unicode.js';